import { render, staticRenderFns } from "./authorityAssignment.vue?vue&type=template&id=2ae45a45&scoped=true&"
import script from "./authorityAssignment.vue?vue&type=script&lang=js&"
export * from "./authorityAssignment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae45a45",
  null
  
)

export default component.exports